import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const TELEGRAM_HANDLE = process.env.REACT_APP_TELEGRAM_HANDLE || "ilveropinko";
export const TELEGRAM_URL = `https://t.me/${TELEGRAM_HANDLE}`;
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || "";

const IPNS_NAME = process.env.REACT_APP_IPNS_NAME || "";
const IPFS_GATEWAY_HOSTS = (process.env.REACT_APP_IPFS_GATEWAYS || "https://ipfs.io,https://dweb.link,https://4everland.io,https://w3s.link")
    .split(",")
    .map((s) => s.trim().replace(/\/+$/, ""))
    .filter(Boolean);

// Multiple backend fallbacks so a cached bundle with stale BACKEND_URL still works
const FALLBACK_BACKEND = process.env.REACT_APP_FALLBACK_BACKEND_URL || "";
const BACKEND_SOURCES = [
    BACKEND_URL ? `${BACKEND_URL}/api/catalog.json` : null,
    FALLBACK_BACKEND ? `${FALLBACK_BACKEND}/api/catalog.json` : null,
].filter(Boolean);

// IPNS gateways are only used if all backends fail.
const IPNS_SOURCES = IPNS_NAME
    ? IPFS_GATEWAY_HOSTS.map((h) => `${h}/ipns/${IPNS_NAME}/`)
    : [];

const EMPTY_CATALOG = {
    version: 1,
    generated_at: null,
    telegram: { handle: TELEGRAM_HANDLE, url: TELEGRAM_URL },
    categories: [],
    products: [],
};

const fetchJson = (url, ms = 12000) =>
    Promise.race([
        fetch(url, { cache: "no-store" }).then((r) => (r.ok ? r.json() : Promise.reject(r.status))),
        new Promise((_, rej) => setTimeout(() => rej("timeout"), ms)),
    ]).then((data) => ({ data, source: url }));

async function raceAll(urls) {
    if (urls.length === 0) throw new Error("no sources");
    return Promise.any(urls.map((u) => fetchJson(u)));
}

export async function loadCatalog() {
    // 1. Try backends FIRST — they're always fresh and respond in <1s
    if (BACKEND_SOURCES.length > 0) {
        try {
            const winner = await raceAll(BACKEND_SOURCES);
            console.log("[catalog] from backend:", winner.source);
            return { ...winner.data, _source: "backend" };
        } catch (e) {
            console.warn("[catalog] all backends failed, trying IPNS:", e);
        }
    }

    // 2. Fallback: IPNS gateways (decentralized, but cache can be 5-10 min stale)
    if (IPNS_SOURCES.length > 0) {
        try {
            const winner = await raceAll(IPNS_SOURCES);
            console.log("[catalog] from IPNS:", winner.source);
            return { ...winner.data, _source: "ipns" };
        } catch (e) {
            console.error("[catalog] all sources failed", e);
        }
    }

    return { ...EMPTY_CATALOG, _source: "empty" };
}
